import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
import { commentService } from '@/presentation/pages/detail/basic/service/CommentService';
import { CopyMoveViewDataServiceSymbol } from '@/presentation/pages/detail/basic/service/CopyMoveViewDataService';
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { useUploadPermission } from '@/presentation/composables/use-upload-permission';
import { UserService } from '@/domains/user/services/user-service.interface';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import _ from 'lodash';
import { CUSTOM_FIELD_LABEL_PERMISSION_TYPES } from '@/domains/detail/folder/constants';
const BulkTaggingDialog = () => import('@/presentation/pages/detail/basic/components/BulkTagging/BulkTaggingDialog.vue');
const detailService = injectService(DetailServiceSymbol);
const copyMoveViewDataService = injectService(CopyMoveViewDataServiceSymbol);
const userService = injectService(UserService);
const spaceService = injectService(SpaceService);
const folderService = injectService(FolderService);
export default class ListOperationServLock {
    constructor() {
        this.detailService = detailService;
    }
    get spaceId() {
        return spaceService.spaceInfo.space_id;
    }
    get folderId() {
        return folderService.folderInfo.folder_id;
    }
    // 弹窗选择复制或者移动的时候，目标文件夹
    async startTargetFolderSelection(mode) {
        throw new Error('Not implemented');
    }
    get maxCount() {
        return this.detailService.maxOp;
    }
    get maxPerFolder() {
        return this.detailService.maxPerFolder;
    }
    get isOverSelectionLimit() {
        return this.selectedCount > this.maxCount;
    }
    get isEditable() {
        if (_.isEmpty(this.detailService.viewData)) {
            console.warn('⚠️ detailService.viewData is empty, you need call detailService.updateViewData(folderId: string, data) first');
        }
        return _.get(this.detailService.viewData, this.detailService.viewDataKeyConfig.edit, false);
    }
    get isMoveable() {
        return this.isEditable;
    }
    get isDeletable() {
        return this.isEditable && !this.isOverSelectionLimit;
    }
    get isExportable() {
        return userService.userPermission.enable_export;
    }
    get isImportable() {
        return userService.userPermission.enable_import;
    }
    get canEditCustomField() {
        return _.includes(CUSTOM_FIELD_LABEL_PERMISSION_TYPES, folderService.folderPermission.field_permission_type);
    }
    get isIndexable() {
        return !this.canEditCustomField || !this.detailService.hasCustomField || this.isOverSelectionLimit;
    }
    postListChange(action, target, requestPayloadOverrides) {
        return copyMoveViewDataService.makeChange({
            spaceId: this.spaceId,
            folderId: this.folderId,
            ...target,
            requestPayloadOverrides,
        });
    }
    onOpenCommentDialog(config) {
        return commentService.open({
            ...config,
        });
    }
    onCloseCommentDialog() {
        return commentService.close();
    }
    getAllowImportStatus() {
        const { uploadDisabledTips } = useUploadPermission();
        if (uploadDisabledTips.value) {
            return {
                value: false,
                message: uploadDisabledTips.value,
            };
        }
        return {
            value: true,
            message: '',
        };
    }
    async openEditCustomFieldDialog() {
        ptDialogAutoMounterManager.update(BulkTaggingDialog, {
            operationService: this,
        });
        await ptDialogAutoMounterManager.openAsPromise(BulkTaggingDialog);
    }
}
